var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.selectedCurrencyId,"items":_vm.currencies,"item-value":"id","item-text":_vm.getCurrencyText,"label":"Select currency","loading":_vm.value,"readonly":_vm.isReadOnly},on:{"change":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }